// extracted by mini-css-extract-plugin
export default {"ExitButton":"PopupButton_ExitButton__xRyrb","Slot2":"PopupButton_Slot2__ZMyY6"};